module.exports = __webpack_public_path__ + "static/media/logo-5-5-paris.037993e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo-5-5-paris.svg
// module id = 1195
// module chunks = 37